import * as React from "react";
import type { SVGProps } from "react";

const SvgLearningCenter = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={22}
    viewBox="0 0 24 22"
    {...props}
  >
    <path
      fill="#142745"
      fillRule="evenodd"
      d="M21.956 20.498h-.412c-.168 0-.402.003-.544-.014.008-.614.512-1.453.748-1.485.241.032.745.872.752 1.485-.141.016-.375.013-.544.014M18 16.1c-.17.34-1.227 1.933-6 1.933-4.82 0-5.85-1.626-6-1.927v-5.33l5.636 3.13a.74.74 0 0 0 .729 0L18 10.775v5.324zM12 1.61 21.706 7 12 12.392 2.295 7 12 1.608zm10.532 16.12V8.5c0-.077-.022-.147-.044-.218l1.127-.626a.751.751 0 0 0 0-1.311L12.365.095a.75.75 0 0 0-.729 0L.386 6.345a.748.748 0 0 0 0 1.31L4.5 9.94v6.295q0 .09.022.177c.079.318.958 3.104 7.478 3.104 6.521 0 7.4-2.786 7.479-3.104a.8.8 0 0 0 .021-.177V9.94l1.532-.85v8.607c-.939.488-1.532 1.836-1.532 2.801 0 .447.134.807.399 1.068.444.442 1.062.441 1.658.432h.387l.186.001c.536 0 1.074-.037 1.472-.433.265-.26.398-.62.398-1.068 0-.943-.565-2.254-1.468-2.769z"
    />
  </svg>
);
export default SvgLearningCenter;
